<template>
  <div class="mt-2">
    <v-tabs
      align-with-title
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - Commissioners Property List' }"
        id="commissionerspropertylist"
        class="input-text-size"
      >
      Property List
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - Commissioners Bidder Registration' }"
        id="commissionersbidderregistration"
        class="input-text-size"
      >
      Bidder Registration
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Delinquent Tax - Commissioners Reports' }"
        id="commissionersresalereports"
        class="input-text-size"
      >
      Reports
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import '../../../../assets/style.css';

export default {
  name: 'CommissionersSale',
  components: {
  },
};
</script>
